import React, { useState, useEffect } from "react";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import pathToRegExp from "path-to-regexp";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Input,
  Table
} from "reactstrap";
import LoaderSpinner from "../../Widgets/LoaderSpinner";

const token = sessionStorage.getItem("token");
const headers = { Authorization: `Bearer ${token}` };

const CategoryGroups = props => {
  const [query, setQuery] = useState("");
  const [categoryGroups, setCategoryGroups] = useState([]);
  const [filteredCategoryGroups, setFilteredCategoryGroups] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [redirectURL, setRedirectURL] = useState(null);

  useEffect(() => {
    fetchCategoryGroups();
  }, []);

  useEffect(
    () => {
      filterCategoryGroups();
    },
    [query]
  );

  const filterCategoryGroups = () => {
    const filtered = categoryGroups.filter(
      group => group.id.includes(query) || group.name.includes(query)
    );
    setFilteredCategoryGroups(filtered);
  };

  const onQuery = e => {
    setQuery(e.target.value);
  };

  const viewCategoryGroup = id => {
    return () => {
      setRedirectURL(`/category-groups/edit/${id}`);
    };
  };

  const renderCategoryGroups = () => {
    return filteredCategoryGroups.map(group => {
      return (
        <tr
          onClick={viewCategoryGroup(group.id)}
          key={group.id}
          className="user-table__item"
        >
          <td>
            <div>{group.name}</div>
          </td>
          <td className="text-center">{group.id}</td>
        </tr>
      );
    });
  };

  const fetchCategoryGroups = async () => {
    try {
      const { data } = await axios.get(`/api/proxy/v2/categoryGroup`, {
        headers
      });

      setCategoryGroups(data);
      setFilteredCategoryGroups(data);
    } catch (e) {
      console.log(e);
    } finally {
      setIsFetching(false);
    }
  };

  if (redirectURL) {
    // grab the :categoryId param from the redirectURL so we can prehydrate data on the next page
    const re = pathToRegExp("/category-groups/edit/:categoryId", []);
    const [_, idParam] = re.exec(redirectURL);
    const catGroupData = categoryGroups.find(group => group.id === idParam);

    return (
      <Redirect
        to={{
          pathname: redirectURL,
          state: {
            categoryGroup: catGroupData,
            referrer: props.location.pathname
          }
        }}
      />
    );
  }

  return (
    <Row>
      <Col xs="12">
        <Card>
          <CardHeader>Filter by Name or Id</CardHeader>
          <CardBody>
            <Input type="text" onChange={onQuery} value={query} />
          </CardBody>
        </Card>
        {isFetching && <LoaderSpinner />}

        {categoryGroups.length ? (
          <Table
            hover
            responsive
            className="table-outline mb-0 d-none d-sm-table user-table"
            key="table"
          >
            <thead className="thead-light">
              <tr>
                <th>Name</th>
                <th className="text-center">ID</th>
              </tr>
              {renderCategoryGroups()}
            </thead>
            <tbody />
          </Table>
        ) : null}
      </Col>
    </Row>
  );
};

export default CategoryGroups;



// WEBPACK FOOTER //
// ./src/views/Pages/Categories/CategoryGroups.js